import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import Header from './Header';
import Footer from './Footer';

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #f8fafc;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  text-align: center;
`;

const ErrorCode = styled.h1`
  font-size: 9rem;
  font-weight: 900;
  color: #0f172a;
  margin: 0;
  line-height: 1;
  letter-spacing: -0.05em;
  background: linear-gradient(135deg, #0f172a 0%, #3b82f6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

const ErrorTitle = styled.h2`
  font-size: 2.5rem;
  font-weight: 700;
  color: #1e293b;
  margin-top: 20px;
  margin-bottom: 15px;
`;

const ErrorDesc = styled.p`
  font-size: 1.15rem;
  color: #64748b;
  max-width: 500px;
  margin-bottom: 40px;
  line-height: 1.6;
`;

const HomeButton = styled.button`
  background-color: #0f172a;
  color: white;
  border: none;
  padding: 16px 36px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);

  &:hover {
    background-color: #1e293b;
    transform: translateY(-3px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }
`;

const PageNotFound = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Header />
      <ContentWrapper>
        <ErrorCode>404</ErrorCode>
        <ErrorTitle>Page Not Found</ErrorTitle>
        <ErrorDesc>
          We couldn't find the page you're looking for. It might have been removed, renamed, or didn't exist in the first place.
        </ErrorDesc>
        <HomeButton onClick={() => navigate('/')}>
          Back to Verification
        </HomeButton>
      </ContentWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default PageNotFound;
